import styled from "styled-components";
import { Wrapper as SelectWrapper } from "../CustomAntdComponents/StyledSelect/styles";
import { BLACK_200, GREY_12, GREY_6, PRIMARY, WHITE } from "../../utils/colors";
import device from '../../utils/mediaQuery';

export const DrawerContent = styled.div`
  padding: 15px;
  height: 85vh;
  
  ${SelectWrapper} {
    .ant-select-selector {
      border: solid 1px ${PRIMARY} !important;
    }
  }
`;

export const Content = styled.div<{ height: string }>`
    padding: 0 16px;    
    max-height: ${({ height }) => `${height}`};
    overflow-y: auto;
    border-radius: 24px !important;
    width: 450px;

    @media (max-width: 768px) {
    width: 100%;
    border-radius: 0 !important;
    height: 100%;
  }
`;

export const PrefixIconWrapper = styled.div`
    display: flex;
    align-items: center;
    column-gap: 5px;
  
    svg {
      width: 20px;
      height: 20px;
    }
`;


export const InputWrapper = styled.div`
  background: ${WHITE};
  padding: 13.2px 11px;
  font-size: 14px;
  border-radius: 12px;
  overflow: hidden;
  font-weight: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.4;
  min-height: 48px;
  display: flex;
  align-items: center;
  column-gap: 5px;
  
  svg {
    path {
        fill: ${BLACK_200} !important;
    }
  }
`;

export const InputDisplay = styled.div`

  @media ${device.large} {
    border: solid 1px ${GREY_6};
  }
`;

export const SearchItem = styled.div`
  border-bottom: solid 1px #EFEFEF;
  padding: 16px 0 12px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;


export const NameWrapper = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
  flex: 1;
  
  svg {
    width: 20px;
    height: 20px;
    
    path {
        fill: #434455 !important;
    }
  }
`;

export const NameContent = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 12px;
  max-height: 40px;
  overflow-y: hidden;
`;

export const SectionTitle = styled.div`
  margin: 12px 0 6px;
`;

export const ListContentWrapper = styled.div`
  overflow-y: auto;
  max-height: calc(100vh - 160px),
`;

export const DesktopPopoverWrapper = styled.div`
  position: relative;
  
  .ant-popover-inner-content {
      width: 100% !important;
      padding: 12px 0;
    }
`;

export const DesktopNewPopoverWrapper = styled.div`
  position: relative;
  // width: 100%;
  
  .ant-popover-inner-content {
      width: 100% !important;
      padding: 12px 0;
    }
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 2px solid #f0a500;
  border-radius: 14px;
  background: #fff;
  margin-bottom: 4px;
`;

export const SearchIcon = styled.span`
  color: #aaa;
  font-size: 15px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 15px;
  color: #1a1a1a;
  background: transparent;
  font-family: inherit;
 
  &::placeholder {
    color: #bbb;
  }
`;

export const MultiDestinationBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin: 12px 0px 12px 0px;
  padding: 13px 16px;
  background: #f5f5f5;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  font-family: inherit;
  transition: background 0.15s ease;
 
  &:hover {
    background: #eeeeee;
  }
 
  svg {
    width: 18px;
    height: 18px;
    color: #666;
  }
`;


export const CustomWrapper = styled.div`
    border: solid 1px ${GREY_6} !important;
    border-radius: 100px !important;
    background: ${WHITE};
    display: flex;
    column-gap: 5px;
    padding: 13.2px 11px;
    
  .ant-picker {
      width: 100%;
      border: none !important;
      border-radius: 12px !important;
      background: none;
      padding: 0;
  }
    .ant-picker-focused {
        box-shadow: none !important;
        border: none !important;
        border-radius: 12px !important;
    }

    .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
    .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
    .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner
    {
        background: ${PRIMARY};
    }

    .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
        border: solid 1px ${PRIMARY};
    }

    .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
    .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,
    .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
        background: ${GREY_12};
    }

    svg {
        width: 20px;
        height: 20px;

        path {
            fill: ${BLACK_200} !important;
        }
    }
`;
